import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {UI} from "../../../stem-core/src/ui/UIBase";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";
import {ActiveButton} from "../../ui/Button.jsx";


export class DonateActiveButtonListStyle extends StyleSheet {
    @styleRule
    buttonList = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
    };

    @styleRule
    label = {
        margin: "18px 0",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        color: this.themeProps.DROPDOWN_COLOR,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    row = {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        ":not(:last-child)": {
            marginBottom: 12
        }
    };

    @styleRule
    shortRowPadding = {
        padding: "0 6%",
    };

    @styleRule
    listItem = {
        flex: 1,
        ":not(:last-child)": {
            marginRight: 6,
        },
        ":not(:first-child)": {
            marginLeft: 6,
        }
    };
}

@registerStyle(DonateActiveButtonListStyle)
export class DonateActiveButtonList extends UI.Element {
    activeButtonIndex = this.options.defaultActiveButtonIndex;
    buttonsRowCountMap = {
        "4": 2,
        "5": 3,
        "6": 3,
        "7": 4,
        "8": 4,
    };

    getDefaultOptions() {
        return {
            label: null,
            defaultActiveButtonIndex: 0,
            items: [],
            onSelect: NOOP_FUNCTION,
            rowSizeLimit: 3,
        }
    }

    extraNodeAttributes(attr) {
        attr.addClass(this.styleSheet.buttonList);
    }

    setOptions(options) {
        if (options.defaultActiveButtonIndex !== this.options.defaultActiveButtonIndex) {
            this.activeButtonIndex = options.defaultActiveButtonIndex;
        }
        return super.setOptions(options);
    }

    getTotalButtonsCount() {
        return this.options.items.length;
    }

    getButtonElements() {

        return this.options.items.map((item, index) => (
            <ActiveButton
                className={this.styleSheet.listItem}
                active={index === this.activeButtonIndex}
                label={item.label}
                onClick={() => this.handleButtonClick(index)}/>
        ));
    }

    render() {
        const {styleSheet} = this;
        const {label, rowSizeLimit} = this.options;
        const rowSize = Math.min(this.buttonsRowCountMap[this.getTotalButtonsCount()] ?? rowSizeLimit, rowSizeLimit);

        return [
            label ? <div className={styleSheet.label}>{label}</div> : <div />,
            this.splitButtonsIntoRows(this.getButtonElements(), rowSize).map(row => <div className={styleSheet.row}>{row}</div>)
        ];
    }

    splitButtonsIntoRows(buttonComponents=[], inputRowSize= 1) {
        let rowSize = inputRowSize;
        const rows = [];
        let i = 0;

        while (i < buttonComponents.length) {
            rows.push(buttonComponents.slice(i, i + rowSize));
            i += rowSize;
            let remainingButtonsAfterNextStep = buttonComponents.length - i;
            if (remainingButtonsAfterNextStep < rowSize) {
                rowSize = remainingButtonsAfterNextStep;
            }
        }
        while (rows.length > 1 && rows[rows.length - 1].length !== inputRowSize) {
            rows[rows.length - 1].push(<div className={this.styleSheet.listItem}/>);
        }

        return rows;
    }

    handleButtonClick(buttonIndex) {
        const {onSelect, items} = this.options;
        this.updateActive(buttonIndex);
        onSelect(items[buttonIndex].value);
    }

    updateActive(index) {
        this.activeButtonIndex = index;
        this.redraw();
    }
}
